enum StorageTypeEnum {
    SESSION_STORAGE = 1,
    LOCAL_STORAGE = 2,
  }

  export default StorageTypeEnum;